if (!customElements.get('share-button')) {
  customElements.define('share-button', class ShareButton extends DetailsDisclosure {
    constructor() {
      super();

      this.elements = {
        shareButton: this.querySelector('.share-button__button'),
        targetButtons: this.querySelectorAll('.share-button__modal-targets button'),
        shareSummary: this.querySelector('summary'),
        inputLabel: this.querySelector('.share-button__modal__copy-input label'),
        closeButton: this.querySelector('.share-button__close'),
        successMessage: this.querySelector('[id^="ShareMessage"]'),
        urlInput: this.querySelector('input')
      }
      this.urlToShare = this.elements.urlInput ? this.elements.urlInput.value : document.location.href;

      window.dataLayer = window.dataLayer || [];

      if (navigator.share) {
        this.elements.shareButton.addEventListener('click', (e) => {
          e.preventDefault();

          window.dataLayer.push({
            event: 'social-share-link',
            socialNetwork: 'native'
          });

          navigator.share({ url: this.urlToShare, title: document.title });
        });
      } else {
        this.mainDetailsToggle.addEventListener('toggle', this.toggleDetails.bind(this));
        this.mainDetailsToggle.querySelector('.share-button__copy').addEventListener('click', this.copyToClipboard.bind(this));
        this.elements.closeButton.addEventListener('click', this.close.bind(this));

        this.elements.targetButtons.forEach(targetButton => {
          targetButton.addEventListener('click', (e) => {
            var url = this.elements.urlInput.value;

            // Needed for Pinterest on PDP
            var pinterestMedia = null;
            var firstProductMediaElem = document.querySelector('.product__media-list img');
            if (firstProductMediaElem) {
              pinterestMedia = firstProductMediaElem.getAttribute('src');
              if (firstProductMedia.startsWith('//')) {
                pinterestMedia = window.location.protocol + firstProductMedia;
              }
            }

            pinterestMedia = targetButton.dataset.imageUrl || firstProductMedia;

            var shareUrl = null;

            switch (e.currentTarget.getAttribute('data-target')) {
              case 'twitter':
                shareUrl = `https://twitter.com/share?text=${encodeURIComponent('Check it out this product!')}&url=${encodeURIComponent(url)}`;
                break;
              case 'whatsapp':
                shareUrl = `https://wa.me/?text=${encodeURIComponent('Check it out this product!')} ${encodeURIComponent(url)}`;
                break;
              case 'facebook':
                shareUrl = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(url)}`;
                break;
              case 'pinterest':
                shareUrl = `https://pinterest.com/pin/create/button/?url=${encodeURIComponent(url)}&media=${encodeURIComponent(pinterestMedia)}`;
                break;
              case 'email':
                shareUrl = `mailto:?body=${encodeURIComponent('Check it out this product!')} ${encodeURIComponent(url)}`;
                break;
            }

            if (shareUrl) {
              window.dataLayer.push({
                event: 'social-share-link',
                socialNetwork: e.currentTarget.getAttribute('data-target')
              });

              window.open(shareUrl, '_blank').focus();
            }
          });
        });
      }
    }

    toggleDetails() {
      if (!this.mainDetailsToggle.open) {
        this.elements.successMessage.classList.add('hidden');
        this.elements.successMessage.textContent = '';
        this.elements.shareSummary.focus();
      }
    }

    copyToClipboard() {
      window.dataLayer.push({
        event: 'social-share-link',
        socialNetwork: 'clipboard'
      });

      navigator.clipboard.writeText(this.elements.urlInput.value).then(() => {
        this.elements.successMessage.classList.remove('hidden');
        this.elements.inputLabel.classList.add('hidden');
        this.elements.successMessage.textContent = window.accessibilityStrings.shareSuccess;
      });
    }

    updateUrl(url) {
      this.urlToShare = url;
      this.elements.urlInput.value = url;
    }
  });
}
